import React from 'react';

interface HandDollarIconProps {
  className?: string;
  width?: number;
  height?: number;
  color?: string;
}

/** @deprecated Use icons from icons-v2-generated instead. */
export const HandDollarIcon: React.FC<HandDollarIconProps> = ({
  className = "",
  width = 24,
  height = 24,
  color = "var(--ods-flamingo-cyan-base)"
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M12.0004 2.75L12 2M12.0004 2.75C10.9844 2.75 10.1727 3.4325 10.1723 4.27344L10.1719 4.2775C10.1715 5.19156 10.984 5.59372 12 5.79688C13.0371 6.00424 13.8281 6.60938 13.8281 7.52344C13.8281 8.47813 13.0164 9.25 12.0004 9.25M12.0004 2.75C13.0164 2.75 13.625 3.35938 13.8281 3.96875M12.0004 9.25L12 10M12.0004 9.25C10.9844 9.25 10.375 8.64062 10.1723 8.03125M2 12.9998H5.5907C6.15409 12.9998 6.71468 13.0791 7.25594 13.2355L10.396 14.1426C10.7569 14.2469 11.1306 14.2998 11.5062 14.2998H13.7899C14.7012 14.2998 15.44 15.0385 15.44 15.9499C15.44 16.6465 15.0084 17.2423 14.3979 17.4844M2.01733 18.9998H3.44737C3.78133 18.9998 4.10998 19.0834 4.40333 19.243L8.00825 21.2047C9.64348 22.0945 11.5818 22.2405 13.3318 21.6056L20.8483 18.8787C21.7577 18.5488 22.2269 17.5437 21.8958 16.6347C21.5653 15.7274 20.5624 15.2593 19.6547 15.5886L14.3979 17.4844M9.94 17.6H13.7899C13.9683 17.6 14.1401 17.5717 14.301 17.5193M14.3979 17.4844L14.301 17.5193M14.3979 17.4844C14.3661 17.497 14.3338 17.5086 14.301 17.5193"
        stroke={color} />
    </svg>

  );
};